import { BankAccount } from '../../Shared/data';
import { ExternalAccount } from '../data';

export const intoBankAccount = (account: ExternalAccount): BankAccount => {
  return {
    ...account,
    graphqlId: '',
    type: 'bank_account',
    isPendingManualLink: false,
  };
};
